<template>
  <div class="container container--pt">
    <div class="columns">
      <div class="column">
        <div class="details__content__box">
          <h2 class="title is-4">{{ $t("bookingRules") }}</h2>
          <ul>
            <li>
              {{ $t("resultsPage.priceDisclaimer") }}
            </li>
            <li v-if="budget">
              {{ $t("resultsPage.budget", { budget: budget }) }}
            </li>
            <li class="pt-3" v-for="a in annotations" v-bind:key="a.title">
              <b>{{ a.title }}</b
              ><br />
              <div v-safe-html="a.text"></div>
            </li>
          </ul>
          <h2 class="title is-4 mt-6">{{ $t("expediaTermsTitle") }}</h2>
          <p class="mb-3">{{ $t("expediaTermsBody") }}</p>
          <p>
            <a
              :href="`https://developer.expediapartnersolutions.com/terms/${$i18n.locale}`"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t("expediaTermsLink") }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHelper from "@/helpers/common.helper";

export default {
  name: "BookingRulesPage",
  data() {
    return {
      annotations: [],
      budget: null
    };
  },
  async mounted() {
    let companyInfo = await CommonHelper.getCompanyInfo();
    if (companyInfo && companyInfo.budget) {
      this.budget = companyInfo.budget;
    }
    let annotations = await CommonHelper.getCompanyAnnotations();
    this.annotations = annotations;
  }
};
</script>
